export default __webpack_public_path__ + "static/media/ev-black.057bc249.svg";